// Marca/consulta se um briefing tem atualização "não vista" pelo usuário atual,
// no mesmo espírito de mensagem pendente no WhatsApp: comparamos a última vez
// que a pessoa abriu aquele briefing (guardado no localStorage, por navegador)
// com o "updated_at" do briefing (que muda a cada edição/status/comentário
// relevante feito por qualquer pessoa).

const KEY_PREFIX = "briefing_seen:"

export function markBriefingSeen(id: string) {
    try {
        localStorage.setItem(KEY_PREFIX + id, new Date().toISOString())
    } catch {
        // localStorage indisponível, ignora
    }
}

export function isBriefingUnread(briefing: { id: string; updated_at?: string; created_at?: string }): boolean {
    if (!briefing?.id) return false
    const changedAt = briefing.updated_at || briefing.created_at
    if (!changedAt) return false

    try {
        const seen = localStorage.getItem(KEY_PREFIX + briefing.id)
        if (!seen) return true
        return new Date(changedAt).getTime() > new Date(seen).getTime()
    } catch {
        return false
    }
}

export function countUnread(briefings: { id: string; updated_at?: string; created_at?: string }[]): number {
    return (briefings || []).filter(isBriefingUnread).length
}
